import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, formValueSelector } from 'redux-form'

import DateTimeForm from './DateTimeForm'
import { createValidator, dateBetween } from 'utils/validations'
import { analytics } from '@src/services/Analytics'
import { getNextServiceDate } from './utils'
import { HORIZON_DAYS } from '@src/globals'

const minServiceDate = getNextServiceDate()
const maxServiceDate = minServiceDate.clone().add(HORIZON_DAYS, 'days').endOf('day')

const validate = createValidator({
  date: dateBetween(minServiceDate, maxServiceDate)
})

const collectAnalytics = (data) => {
  const eventData = {
    service_type_id: data.serviceTypeId,
    date: data.date,
    time: data.time
  }

  analytics.datetimeSubmit(eventData)
}

const formSelector = formValueSelector('booking')

export default function (props) {
  const {
    user,
    initialValues,
    onSubmit
  } = props

  const handleSubmit = (data) => {
    collectAnalytics(data)
    onSubmit(data)
  }

  const Form = reduxForm({
    form: 'booking',
    initialValues,
    validate,
    onSubmit: handleSubmit
  })(DateTimeForm)

  const ConnectedForm = connect(
    state => ({
      selectedServiceTypeId: formSelector(state, 'serviceTypeId')
    })
  )(Form)

  return <ConnectedForm user={user} />
}



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/ServiceSetup/screens/DateTimeForm/DateTimeFormContainer.js